import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class DonationWayService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetDonationWay():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationWay/GetDB`);
  }
  GetDonationWayByid(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationWay/GetByIdDB?Id=${id}`);
  }
  GetDonationWayPaged(pager:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationWay/GetPagedDB`,pager);
  }
  DeleteDonationWay(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationWay/Delete?id=${id}`);
  }

  CreateDonationWay(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationWay/Create`,data);
  }
  UpdateDonationWay(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationWay/Update`,data)
  }



}
